import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SmartImage from '@/components/base/SmartImage';
import SectionHeading from '@/components/feature/SectionHeading';
import { categoryCards, otherCategories } from '@/mocks/homeData';
import { getCategoryImagePath } from '@/pages/products/productUtils';

export default function CategorySection() {
  return (
    <section id="categories" className="relative w-full bg-primary-900 py-14 md:py-20 overflow-hidden">
      <div className="pointer-events-none absolute top-0 right-0 w-96 h-96 rounded-full bg-primary-700/40 blur-3xl"></div>
      <div className="pointer-events-none absolute bottom-0 left-0 w-72 h-72 rounded-full bg-secondary-700/30 blur-3xl"></div>

      <div className="relative w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Our Ayurvedic Medicines"
          title="Explore Our Product Range"
          description="From capsules and syrups to traditional lehyam, every formulation is prepared with pure herbs and time-honoured Ayurvedic wisdom."
          tone="dark"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {categoryCards.map((card, index) => (
            <Reveal key={card.id} delay={index * 120}>
              <article className="group h-full flex flex-col rounded-lg bg-background-50 overflow-hidden border border-primary-700/40">
                <Link to={card.to} className="relative block w-full h-56 overflow-hidden cursor-pointer">
                  <SmartImage
                    preferredSrc={getCategoryImagePath(card.id)}
                    fallbackSrc={card.image}
                    alt={`Ayurvedic ${card.name} manufactured by Best Research Pharma`}
                    title={`${card.name} - Ayurvedic products by Best Research Pharma`}
                    className="w-full h-full object-top object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-transparent"></div>
                  <span className="absolute top-4 left-4 w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-primary-950">
                    <i className={`${card.icon} text-lg`}></i>
                  </span>
                </Link>
                <div className="flex flex-col flex-1 p-5 md:p-6">
                  <h3 className="font-heading text-xl font-semibold text-foreground-950">{card.name}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600 flex-1">{card.description}</p>
                  <Link
                    to={card.to}
                    className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-primary-700 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    View Products
                    <i className="ri-arrow-right-line text-base"></i>
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {otherCategories.map((item, index) => (
            <Reveal key={item.id} delay={index * 100}>
              <Link
                to={item.to}
                className="flex items-center gap-4 p-4 rounded-lg bg-primary-800/70 border border-primary-700/50 hover:bg-primary-800 transition-colors cursor-pointer"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-500 text-primary-950 shrink-0">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <span className="flex flex-col">
                  <span className="font-heading text-base font-semibold text-background-50">{item.name}</span>
                  <span className="text-xs text-background-100/75 mt-0.5">{item.description}</span>
                </span>
                <i className="ri-arrow-right-line text-background-100/70 ml-auto text-lg"></i>
              </Link>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/products"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-primary-950 text-sm font-semibold hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-shopping-bag-3-line text-base"></i>
            View All Products
          </Link>
        </div>
      </div>
    </section>
  );
}